import _ = require('underscore');
import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { Set } from '../../../ts/models/Set';
import { SetOfUsers } from '../../../ts/models/SetOfUsers';
import { ServerUsers } from '../../services/resources/ServerUsers';
import { IUpdateServerUsersSiteMembershipResult } from '../../../ts/ServerApi/requests/UpdateServerUsersSiteMembershipRequest';
import { IUserActionResult, UserActionResultCode } from '../../../ts/ServerApi/types/IUserActionResult';
import { AuthenticationProviderType, IAuthenticationProvider } from '../../../settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { SiteRolesPickerClientService } from '../../services/SiteRolesPickerClientService';
import { SiteMembershipUpdateActionNotification } from '../../services/notifications/SiteMembershipUpdateActionNotification';
import { UserActionNotification } from '../../services/notifications/UserActionNotification';
import { AddLocalUsersDialogProps, INewUserFlowModel } from '../AddLocalUsersDialog';
import { ISiteRoleChanges } from '../SiteRolesPickerContainer';
import {AuthenticationTypeResolutionService} from '../../../authentication/services/AuthenticationTypeResolutionService';

export class CreateLocalServerUserHelperService {
  private userActionNotification: UserActionNotification = UserActionNotification.instance;
  private siteMembershipUpdateActionNotification: SiteMembershipUpdateActionNotification = SiteMembershipUpdateActionNotification.instance;

  public createLocalServerUser(username: string, model: INewUserFlowModel, authenticationProvider: IAuthenticationProvider,
                            siteRoleChanges: ISiteRoleChanges, props: AddLocalUsersDialogProps, setBusyState: (busy: boolean) => void) {
    let action: ng.IPromise<IUserActionResult>;
    const isLocalAuth = authenticationProvider.type === AuthenticationProviderType.default && !AuthenticationTypeResolutionService.isAuthenticationSaml();
    if (isLocalAuth) {
      action = ServerUsers.instance.createLocalServerUser(
      username,
      model.displayName,
      model.email,
      model.password);
    } else {
      action = ServerUsers.instance.createLocalServerUserWithoutPassword(
        username,
        model.displayName,
        model.email
      );
    }
    action.then((result: IUserActionResult) => {
      if (!!result.errors && result.errors.length > 0) {
        setBusyState(false);
      } else {
        this.onServerUserCreateSuccess(result, siteRoleChanges, props);
      }
    });
  }

  public onServerUserCreateSuccess(result: IUserActionResult, siteRoleChanges: ISiteRoleChanges, props: AddLocalUsersDialogProps) {
    // create an interfaced object for the created user
    const addedUser: IUserInfo = {
      id: result.users[0].id,
      authId: result.users[0].authId,
      username: result.users[0].username,
      displayName: result.users[0].displayName
    };

    // update site membership
    if (siteRoleChanges.serverAdmin) {
      this.updateServerAdmin(addedUser, siteRoleChanges, props);
    } else if (!_.isEmpty(siteRoleChanges.siteRoles)) {
      this.updateSiteMembership(addedUser.id, addedUser.authId, addedUser.username, addedUser.displayName, siteRoleChanges, props);
    } else {
      this.showNotificationForCreateServerUser(addedUser, result, props);
    }
  }

  public showNotificationForCreateServerUser(user: IUserInfo, result: IUserActionResult, props: AddLocalUsersDialogProps){
    this.userActionNotification.notify({
      users: Set.fromIdItemArray(result.users),
      results: result.results,
      errors: result.errors,
      successCode: UserActionResultCode.systemUserCreated
    });
    props.close(user);
  }

  // section: update server admin

  public updateServerAdmin(user: IUserInfo, siteRoleChanges: ISiteRoleChanges, props: AddLocalUsersDialogProps) {
    const users = SetOfUsers.singletonForUser(user);
    const newAdminState = (siteRoleChanges.serverAdmin === CheckboxState.checked);
    SiteRolesPickerClientService.updateServerAdmin(users, newAdminState).then(() => {
      props.close(user);
    });
  }

  // section: update site membership or roles

  public updateSiteMembership(userId: string, authUserId: string, username: string, userDisplayName: string, siteRoleChanges: ISiteRoleChanges, props: AddLocalUsersDialogProps) {
    const params = SiteRolesPickerClientService.siteRoleChangesToParams([userId], siteRoleChanges.siteRoles);
    SiteRolesPickerClientService.updateServerUsersSiteMembership(params)
      .then((result: IUpdateServerUsersSiteMembershipResult) => {
        // create a Set<T> object for the result notification system
        const addedUser: IUserInfo = {
          id: userId,
          authId: authUserId,
          username: username,
          displayName: userDisplayName
        };
        const users = SetOfUsers.singletonForUser(addedUser);

        if(result.results){
          this.siteMembershipUpdateActionNotification.notify(
              result.results,
              result.errors,
              users,
              siteRoleChanges.siteRoles);
        }
        props.close(addedUser);
      });
  }
}
